import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ApiService } from "../ApiService";

const ModalSearchProduct = ({ isOpen, onClose, onAddProduct, selectedProducts, allProducts = [], selectedCategory, selectedBrand }) => {
  const [searchValue, setSearchValue] = useState("");
  const [productOptions, setProductOptions] = useState([]); // Todos los productos
  const [filteredOptions, setFilteredOptions] = useState([]); // Productos filtrados

  useEffect(() => {
    if (isOpen) {
      setProductOptions(allProducts); // Guardar todos los productos obtenidos
      setFilteredOptions(allProducts); // Inicializar con todos los productos
    }
  }, [isOpen]);

  // Filtrar productos basados en el término de búsqueda y los productos ya seleccionados
  useEffect(() => {
    // 1) Partimos de allProducts
    let filtered = allProducts;
  
    // 2) Si hay categoría seleccionada
    if (selectedCategory) {
      filtered = filtered.filter((p) => p.category === selectedCategory);
    }
    // 3) Si hay marca seleccionada
    if (selectedBrand) {
      filtered = filtered.filter((p) => p.brand === selectedBrand);
    }
  
    // 4) Excluir los ya agregados en la tabla
    filtered = filtered.filter(
      (product) => !selectedProducts.some((sel) => sel.code === product.code)
    );
  
    // 5) Filtrar también por el término de búsqueda (searchValue)
    if (searchValue.trim()) {
      filtered = filtered.filter((product) =>
        product.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
  
    setFilteredOptions(filtered);
  }, [
    allProducts,
    selectedProducts,
    selectedCategory,
    selectedBrand,
    searchValue,
  ]);
  

  // Manejar cambios en el input de búsqueda
  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  // Seleccionar un producto
  const handleSelectProduct = (product) => {
    onAddProduct(product); // Agregar el producto a la lista del componente padre

    // Eliminar el producto seleccionado de las opciones disponibles
    const updatedOptions = productOptions.filter((item) => item.code !== product.code);
    setProductOptions(updatedOptions); // Actualizar la lista de productos
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-search">
      <div className="modal-content-search">
        {/* Botón de cerrar */}
        <button className="close-modal-btn" onClick={onClose}>
          ✖
        </button>

        <h3 style={{ fontSize: "22px", marginBottom: "0px" }}>Agregar Producto</h3>

        {/* Input de búsqueda */}
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Buscar producto..."
            value={searchValue}
            onChange={handleInputChange}
          />

          {/* Opciones filtradas */}
          {filteredOptions.length > 0 ? (
            <div className="search-results-product">
              {filteredOptions.map((item) => (
                <div
                  key={item.code}
                  className="result-item"
                  onClick={() => handleSelectProduct(item)}
                >
                  <span className="result-code">{item.code}</span>
                  <span className="result-name">{item.name}</span>
                </div>
              ))}
            </div>

          ) : (
            <div className="no-results">No se encontraron resultados.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalSearchProduct;
